import { Component, Input, ViewEncapsulation, HostBinding, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../animations/page-transitions';
import { GuaranteeRequestService, REQUEST_FIELDS } from '../../../guarantee/services/guarantee-request.service';
import { OrderBy, OrderByDirection } from '../../utils/constant';
import { Guarantee } from '../../../guarantee/models/guarantee';
import { NumberPipe } from '../../pipes/number.pipe';
import { LoadingSpinnerComponent } from '../utils/loading-spinner.component';

@Component({
	selector: 'copo-request-guarantee-widget',
	templateUrl: './guarantee-request-widget.component.html',
	styleUrl: './guarantee-request-widget.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		TranslateModule,

		MatButtonModule,
		RouterLink,
		MatIconModule,
		LoadingSpinnerComponent,
		NumberPipe
	]
})
export class GuaranteeRequestWidgetComponent implements OnDestroy {
	@HostBinding('class.services-box') box = true;
	@Input() headerLabel!: string;
	@Input() btnLabel!: string;
	@Input() btnRouterLink!: string;
	filters = '';
	draftCount = 0;
	isLoading = true;
	draftCountSubscription: Subscription;

	constructor(
		private readonly guaranteeRequestService: GuaranteeRequestService,
	) {
		this.draftCountSubscription = this.guaranteeRequestService.getRequests(
			REQUEST_FIELDS,
			this.guaranteeRequestService.getByDraftStatusFilter(),
			1,
			100,
			[new OrderBy('requestDate', OrderByDirection.DESC)],
			true,
			false
		).subscribe({
			next: res => {
				this.draftCount = res.count;
				this.isLoading = false;
			},
			error: (err: unknown) => {
				console.error('unable to retrieve guarantee draft count', err);
				this.isLoading = false;
			}
		});
	}

	newGuarantee() {
		this.guaranteeRequestService.guarantee = new Guarantee();
	}

	ngOnDestroy() {
		this.draftCountSubscription.unsubscribe();
	}
}
